// Ô THAM SỐ CÓ TẬP GIÁ TRỊ CỐ ĐỊNH (05/10/2026 — người dùng: "phải gõ mã kỹ thuật khong / luon / ti_le") — phần thuần dùng chung trang Kịch bản
// (thẻ sơ đồ + bảng thêm bước) và Gói seeding:
//  - nhãn tiếng Việt cho từng giá trị (ô chọn hiện nhãn, gửi máy chủ đúng mã);
//  - nhãn ô bỏ phần gợi ý mã "(a / b / c)" của bản đồ (bản đồ giữ nguyên cho AI đọc);
//  - luật ẩn/hiện theo ô khác: "Tỉ lệ kèm ảnh" chỉ khi "Theo tỉ lệ"; ô ảnh + "khi lỗi" chỉ khi kèm ảnh ≠ Không.
// Rà bản đồ v0 (05/10/2026): tham số có luaChon CHỈ có kem_anh và khi_loi_anh (mọi thao tác bình luận / trả lời Facebook, X, Reddit).
// Tham số enum mới (Super thêm luaChon trong bản đồ) tự thành ô chọn; thiếu nhãn ở đây thì hiện mã bỏ gạch dưới.
import { tomTatAnhChon } from "./kho-anh";
import { chuanCauHinhVideo } from "./video-dang";

export const NHAN_GIA_TRI: Readonly<Record<string, Readonly<Record<string, string>>>> = {
  kem_anh: { khong: "Không kèm ảnh", luon: "Luôn kèm ảnh", ti_le: "Theo tỉ lệ" },
  khi_loi_anh: { chi_chu: "Chỉ gửi chữ (bỏ ảnh)", bo_muc: "Bỏ câu này" },
  tu_tra_loi_cau_hoi: { co: "Có — AI tự trả lời", khong: "Không — để người trả lời" },
  chi_bai_lien_quan: { co: "Có — chỉ bình luận bài liên quan", khong: "Không — bình luận cả bài không liên quan" },
};

/** Giải thích ngắn từng giá trị (title của ô chọn). */
export const GIAI_THICH_GIA_TRI: Readonly<Record<string, Readonly<Record<string, string>>>> = {
  kem_anh: { khong: "Chỉ gửi chữ như trước", luon: "Mọi câu bình luận / trả lời đều kèm một ảnh", ti_le: "Chỉ một phần số câu kèm ảnh (đặt % ở ô bên dưới)" },
  khi_loi_anh: { chi_chu: "Không đính được ảnh (kho rỗng, ảnh lỗi, ô soạn không có nút ảnh) thì vẫn gửi chữ", bo_muc: "Không đính được ảnh thì bỏ hẳn câu đó, không gửi" },
  tu_tra_loi_cau_hoi: { co: "Nhóm hỏi câu hỏi khi xin vào: AI trả lời ngắn đúng câu hỏi, chọn đáp án, đồng ý nội quy rồi Gửi (không điền số điện thoại / email / giấy tờ)", khong: "Đóng hộp câu hỏi, ghi 'cần người' để bạn tự trả lời" },
  chi_bai_lien_quan: { co: "Trước khi soạn, AI chấm từng bài và chỉ bình luận bài đúng chủ đề (từ khoá / sản phẩm / mục tiêu)", khong: "Bỏ bước AI chấm: bình luận mọi bài lấy được, kể cả bài không đúng chủ đề" },
};

export function nhanGiaTri(ten: string, v: string): string {
  return NHAN_GIA_TRI[ten]?.[v] ?? v.replace(/_/g, " ");
}

/** Nhãn ô: bỏ đuôi "(mã / mã …)" (gợi ý cho AI) — "Kèm ảnh (khong / luon / ti_le)" → "Kèm ảnh". Đuôi không có "/" (vd "(%)") giữ nguyên. */
export function nhanThamSo(nhan: string): string {
  return nhan.replace(/\s*\([^()]*\/[^()]*\)\s*$/, "").trim() || nhan;
}

// ten → (giá trị các ô của bước) → có HIỆN không. Ô trống = giá trị mặc định của kem_anh ("khong").
const kemAnh = (gt: Record<string, string | undefined>): string => (gt.kem_anh ?? "").trim() || "khong";
const LUAT_HIEN: Readonly<Record<string, (gt: Record<string, string | undefined>) => boolean>> = {
  tu_khoa_cau_hinh: () => false, // (06/10/2026) cấu hình nhiều từ khoá do bảng "Từ khoá" tự ghi — không có ô riêng
  ti_le_anh: (gt) => kemAnh(gt) === "ti_le",
  anh_chon: (gt) => kemAnh(gt) !== "khong",
  khi_loi_anh: (gt) => kemAnh(gt) !== "khong",
};

/** Ô tham số `ten` có bị ẨN với các giá trị hiện tại không (chỉ ẩn trên giao diện — giá trị đã có vẫn giữ / gửi như cũ). */
export function thamSoAn(ten: string, gt: Record<string, string | undefined>): boolean {
  const f = LUAT_HIEN[ten];
  return f ? !f(gt) : false;
}

/** Giá trị hiện trong dòng tóm tắt của thẻ gọn: ô chọn → nhãn; anh_chon → tóm tắt tập ảnh; còn lại nguyên chữ. */
export function giaTriHien(ten: string, v: string, tenSp?: Record<string, string>): string {
  if (ten === "anh_chon") return tomTatAnhChon(v, tenSp);
  if (ten === "cau_hinh_video") { const c = chuanCauHinhVideo(v); return `${c.che_do === "thu" ? "Thử (riêng tư)" : "Công khai"}, tối đa ${c.tran} video/ngày`; } // 06/10/2026: bước Đăng video — không hiện chữ kỹ thuật
  if (NHAN_GIA_TRI[ten]) return nhanGiaTri(ten, v);
  return v;
}
